import { createStore } from 'idb-keyval';

const offlineTrfStore = createStore('OFFLINE_TRF_DB', 'TRF_DB');

export default offlineTrfStore;
